import React from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../shared';

export const AnalysisRequestAddReportModal = ({ props, modalRespInfo, showModal, setShowModal, modalHeader }) => {
    const digitsOnly = (value) => /^\d+$/.test(value);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            age: '',
            name: '',
        },
        validationSchema: Yup.object({
            age: Yup.string().test('Digits only', 'Defina la edad. (sólo puede contener números)', digitsOnly),
        }),
        onSubmit: (values, { resetForm }) => {
            modalRespInfo(values);
            resetForm();
            setShowModal(false);
        }
    });

    const { className } = props;

    const toggle = () => {
        setShowModal(false);
    };

    const onClosed = () => {
        validation.resetForm();
    };

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="success"
                label="Guardar"
                icon="mdi mdi-content-save"
                isLoading={false}
                onClick={validation.handleSubmit}
                className="rounded-3 me-2"
                outline
            />
            <BaseCustomButton
                color="danger"
                label="Cancelar"
                icon="mdi mdi-close-circle-outline"
                isLoading={false}
                onClick={toggle}
                className="rounded-3 me-3"
                outline
            />
        </div>
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
                <h4 className="text-primary m-0 ps-4">{modalHeader}</h4>
            </label>
        </div>
    );

    return (
        <>
            <BaseCustomModal
                title={title}
                isModalOpen={showModal}
                handleCancel={toggle}
                onClosed={onClosed}
                zIndex={9999}
                width="60%"
                className={className}
                footer={buttons}
            >
                <GradientDecorationLine />
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <div className="px-4 mx-3 mb-4">
                        <label className="text-primary mt-3">Edad</label>
                        <Input
                            name="age"
                            className="form-control text-primary text-center"
                            placeholder="Edad del informe"
                            type="number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.age || ''}
                            invalid={validation.touched.age && validation.errors.age}
                            onFocus={(e) => e.target.select()}
                        />
                        {validation.touched.age && validation.errors.age && (
                            <FormFeedback type="invalid">{validation.errors.age}</FormFeedback>
                        )}
                        <label className="text-primary mt-3">Informes Parciales</label>
                        <textarea
                            name="name"
                            required
                            className="form-control text-primary rounded-3"
                            rows="7"
                            placeholder="Informes Parciales"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ''}
                        />
                    </div>
                    <GradientDecorationLine />
                </Form>
            </BaseCustomModal>
        </>
    );
};
